import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import { formatRangeValue } from '@features/filter/static/filterUtil';
import FilterInput from '@features/filter/v2/FilterInput';
import FilterName from '@features/filter/v2/FilterName';

import {
	clearSelectedFilterName,
	storeItemInGlobalFilter,
	storeSelectedFilterCheckboxType
} from '@store/actions/FilterAction';

const ProductionPrice = () => {
	const [priceRangeValue, setPriceRangeValue] = useState({ min: '', max: '' });
	const dispatch = useDispatch();
	const priceRengeRef = useRef(null);
	const { selectedCheckboxField } = useSelector((store) => store.slectedCheckBoxFieldStore);

	const onOutSideClick = () => {
		if (selectedCheckboxField === 'PRODUCTION_PRICE') dispatch(clearSelectedFilterName());
	};

	useClickOutside(priceRengeRef, onOutSideClick);

	const onApplyPriceRange = () => {
		let data = {
			name: 'PRODUCT_PRICE_RANGE',
			minPrice: parseFloat(priceRangeValue.min),
			maxPrice: parseFloat(priceRangeValue.max),
			key: priceRangeValue,
			value: `Price: ${formatRangeValue(priceRangeValue, '$')}`,
			identifier: `priceRangeV2Ids`,
			type: 'INPUT_VALUE'
		};
		dispatch(storeItemInGlobalFilter(data));
		onClearInput();
		dispatch(storeSelectedFilterCheckboxType(null));
	};

	const onClearInput = () => {
		setPriceRangeValue({ min: '', max: '' });
	};

	const onChangePrice = (e) => {
		const { name, value } = e.target;
		setPriceRangeValue((prev) => ({
			...prev,
			[name]: value
		}));
	};
	return (
		<div ref={priceRengeRef}>
			<FilterName type="PRODUCTION_PRICE" />
			<FilterInput
				inputValue={priceRangeValue}
				onChangeHandler={onChangePrice}
				onApplyHandler={onApplyPriceRange}
				placeHolderOne="Min"
				placeHolderTwo="Max"
				type="PRODUCTION_PRICE"
				onClearInputFields={onClearInput}
			/>
		</div>
	);
};

export default ProductionPrice;
